'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _isNull2 = require('lodash/isNull');

var _isNull3 = _interopRequireDefault(_isNull2);

var _defaults2 = require('lodash/defaults');

var _defaults3 = _interopRequireDefault(_defaults2);

var _isUndefined2 = require('lodash/isUndefined');

var _isUndefined3 = _interopRequireDefault(_isUndefined2);

var _isPlainObject2 = require('lodash/isPlainObject');

var _isPlainObject3 = _interopRequireDefault(_isPlainObject2);

var _isFunction2 = require('lodash/isFunction');

var _isFunction3 = _interopRequireDefault(_isFunction2);

var _forEach2 = require('lodash/forEach');

var _forEach3 = _interopRequireDefault(_forEach2);

var _isArray2 = require('lodash/isArray');

var _isArray3 = _interopRequireDefault(_isArray2);

exports.default = value;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function value(attribute, args) {
    if ((0, _isArray3.default)(attribute)) {
        var result = void 0;
        (0, _forEach3.default)(attribute, function (attr) {
            attr = (0, _isFunction3.default)(attr) ? attr(args) : attr;
            if ((0, _isPlainObject3.default)(attr) && (0, _isUndefined3.default)(attr._owner) && (0, _isUndefined3.default)(attr.props)) {
                result = (0, _defaults3.default)(result || {}, attr);
            } else if (!(0, _isUndefined3.default)(attr) && !(0, _isNull3.default)(attr)) {
                result = attr;
                return false;
            } else {
                return true;
            }
        });
        return result;
    } else {
        return (0, _isFunction3.default)(attribute) ? attribute(args) : attribute;
    }
}


/*****************
 ** WEBPACK FOOTER
 ** ../~/rumble-charts/lib/helpers/value.js
 ** module id = 1583
 ** module chunks = 3
 **/